import totalImoveisAgencia from './apiFunctions/totalImoveisAgencia';
import listarDestaques from './apiFunctions/listarDestaques';
import listarBannerGDN from './listarBannerGDN';
import { Controller, Scene } from 'scrollmagic';
import pesquisarImoveis from './apiFunctions/pesquisarImoveis';
import getRandomInt from './utils/getRandomInt';
import { returnCurrency, smoothScroll, finalidadeParametro } from './generalFunctions';

import { removeAccents, capitalizeString, matchHeightElements, loadCardImages, setPaginationUrl } from './generalFunctions';

const agenciaOrder = document.querySelector('section.template-agencia').getAttribute('data-order');

totalImoveisAgencia(finalidadeParametro(false, true), (totalImoveis) => {
  document.querySelector('p.total-imovel').innerHTML = totalImoveis + ' Imóveis';
});

class agencia {
  constructor () {
    const self = this;
    this.paginasTotal = 0;
    this.bannerArrayHtml = new Array();
    this.aux = 0;
    this.pagina = 1;
 }
  listarDestaquePronto() {
    var destaque = document.querySelector('.novo_codigo_destaque') ? document.querySelector('.novo_codigo_destaque').innerText.trim() : 0;
    listarDestaques(finalidadeParametro(), agenciaOrder, 50, destaque, (cb) => {
      const imovel = cb[getRandomInt(0, cb.length)];
      if (!imovel) {
        return;
      }
      const valorSobConsulta = Array('63509');
      const url = `${removeAccents(imovel.CategoriaImovel)}-${removeAccents(imovel.AreaPrivativa)}m2-${imovel.Status}-${removeAccents(imovel.Bairro)}-${imovel.Codigo}/`.toLowerCase();
      const element = document.querySelector('#imovel-destaque');
      const html = `<div class="imovel-content-card">
                      <div class="relative placeholder" data-large="${imovel.FotoDestaque.replace("http://", "https://")}">
                        <img class="object-fit-image img-small" src="${imovel.FotoDestaquePequena.replace("http://", "https://")}" alt="${imovel.TituloImovel}" loading="lazy">
                        <div class="imovel-content-card-gradient"></div>
                        <div class="badge">
                          ${((imovel.ProntoNovoMorar === 'Sim' || imovel.ProntoParaMorar === 'Sim' ||imovel.ProntoMorar === 'Sim' ) && (imovel.Lancamento === 'Sim' || imovel.Lancamentos2 === 'Sim' ) ) ? '<span class="badge-prontoNovoMorar">Pronto para morar</span>' : ''}
                          ${((imovel.ProntoNovoMorar === 'Sim' || imovel.ProntoParaMorar === 'Sim' ||imovel.ProntoMorar === 'Sim' ) && imovel.LancamentosProntos === 'Sim') ? '<span class="badge-prontoNovoMorar">Pronto para morar</span>' : ''}
                          ${((imovel.Lancamentos2 === 'Sim') && (imovel.ProntoNovoMorar === 'Nao' || imovel.ProntoParaMorar === 'Nao' ||imovel.ProntoMorar === 'Nao' )) ? '<span class="badge-lancamento">Lançamento</span>' : ''}
                          ${((imovel.LancamentosProntos === 'Sim' || imovel.Lancamentos2 === 'Sim' ) && (imovel.ProntoNovoMorar === 'Nao' || imovel.ProntoParaMorar === 'Nao' ||imovel.ProntoMorar === 'Nao' )) ? '<span class="badge-lancamento">Lançamento</span>' : ''}
                          ${(imovel.EmConstrucao === 'Sim' ) ? '<span class="badge-EmConstrucao">Em construção</span>' : ''}
                        </div>
                        ${imovel.Proposta === 'Sim' ? '<span class="badge-reservado">Imóvel com proposta</span>' : ''}
                        <a class="card-link" href="${phpData.homeurl}imovel/${url}"></a>
                        <div class="imovel-content-card-info d-flex flex-column align-items-start justify-content-end">
                          <h3>${imovel.Bairro}</h3>
                          <p>${imovel.TituloImovel}</p>
                          <div class="group-icons d-flex flex-wrap align-items-center justify-content-start">
                            ${
                              imovel.Dormitorios ?
                                `<div class="d-flex align-items-center">
                                  <i class="fal fa-bed"></i>
                                  <span>${imovel.Dormitorios} Quartos</span>
                                </div>` : ''
                            }
                            <div class="d-flex align-items-center">
                              <i class="fal fa-building"></i>
                              <span>${imovel.AreaPrivativa}m²</span>
                            </div>
                            ${imovel.OcultarPrecoSite !== 'Sim' && !valorSobConsulta.includes(imovel.Codigo) ?
                              `<div class="align-self-end flex-grow-1">
                                <p class="price">R$ ${imovel.Status === 'VENDA' ? returnCurrency(imovel.ValorVenda) : returnCurrency(imovel.ValorLocacao)}</p>
                              </div>` : ''
                            }
                            ${valorSobConsulta.includes(imovel.Codigo) ?
                              `<div class="align-self-end flex-grow-1">
                                ${valorSobConsulta.includes(imovel.Codigo) ? `<span class="badge-valor-sob-consulta">Valor Sob Consulta</span>` : ''}
                              </div>` : ''
                            }
                          </div>
                        </div>
                        <div class="card-animation"></div>
                      </div>
                    </div>`;
      element.insertAdjacentHTML('beforeend', html);
      const cards = Array.from(document.querySelectorAll('#imovel-destaque .imovel-content-card'));
      loadCardImages(cards, 'object-fit-image');
    });
  };

  goToPage(e, item) {
    e.preventDefault();
    smoothScroll('agencia-cards', 'fixed');
    const pagina = item.dataset.value;
    setPaginationUrl(pagina);
    this.listarImoveis(Number(pagina));
  };

  listPaginationPages(self) {
    const buttons = Array.from(document.querySelectorAll('#paginacao li a'));
    buttons.map((item, e) => {
      item.addEventListener('click', function(e) {
        self.goToPage(e, item);
      })
    })
  };

  mountPaginationTemplate(pagina = 1, paginasTotal, totalImoveis, self, callback) {
    if (!totalImoveis) {
      callback()
      return;
    }
    const paginaAtual = Number(pagina);
    const paginacao = document.getElementById('paginacao');
    if (paginacao) {
      paginacao.remove();
    }
    const element = document.querySelector('#agencia-cards');
    const html = `<nav id="paginacao">
                    <ul class="pagination justify-content-center">
                      ${paginaAtual-1 > 0 ?
                        `<li class="page-item d-none d-lg-block">
                          <a class="page-link" href="#" aria-label="Prev" data-value="${paginaAtual-1}">
                            <button class="button button-brown">Página anterior</button>
                          </a>
                        </li>` : ''
                      }
                      ${paginaAtual-2 > 0 ?
                        `<li class="page-item"><a class="page-link" href="#" data-value="${paginaAtual-2}">${paginaAtual-2}</a></li>`: ''
                      }
                      ${paginaAtual-1 > 0 ?
                        `<li class="page-item"><a class="page-link" href="#" data-value="${paginaAtual-1}">${paginaAtual-1}</a></li>`: ''
                      }

                      <li class="page-item"><a class="page-link page-number-selected" href="#" data-value="${paginaAtual}">${paginaAtual}</a></li>

                      ${paginaAtual+1 <= paginasTotal ?
                        `<li class="page-item"><a class="page-link" href="#" data-value="${paginaAtual+1}">${paginaAtual+1}</a></li>`: ''
                      }
                      ${paginaAtual+2 <= paginasTotal ?
                        `<li class="page-item"><a class="page-link" href="#" data-value="${paginaAtual+2}">${paginaAtual+2}</a></li>`: ''
                      }
                      ` +
                     //  ${ paginaAtual <= 1 ?
                     //   `<li class="page-item"><a class="page-link" href="#" data-value="${paginaAtual+2}">${paginaAtual+2}</a></li>` : ''
                     // }
                     `
                     ${ paginaAtual+1 <= paginasTotal ?
                         `<li class="page-item d-none d-lg-block">
                           <a class="page-link" href="#" aria-label="Next" data-value="${paginaAtual+1}">
                             <button class="button button-brown">Próxima página</button>
                           </a>
                         </li>` : ''
                     }
                    </ul>
                  </nav>`;
    element.insertAdjacentHTML('afterend', html);
    callback(self);
  };

  setDataLayerAgenciaUnico(classe, paginacao) {
  const imoveis = Array.from(document.querySelectorAll(`${classe} .imovel-content-card`));
  const itensTotal = paginacao * 9 - 9;
  imoveis.map((imovel, key) => {
    const itemPosition = itensTotal + key + 1;

    imovel.addEventListener('click', (e) => {
      const card = e.target.closest('.imovel-content-card');
      const dataTracker = card.querySelector('.tracker-info');
      const imovelInfo = JSON.parse(dataTracker.dataset.tracker);

      const preco = parseInt(imovelInfo.CodigoAgencia) === 2 ? parseInt(imovelInfo.ValorLocacao) : parseInt(imovelInfo.ValorVenda);
      const finalidade = () => {
        const info = finalidadeParametro();
        if (info.Status === 'Aluguel') {
          return 'Locação';
        } else if (info.Status === 'Venda' && info.Lancamento === 'Sim') {
          return 'Lançamentos';
        } else {
          return 'Prontos';
        }
      }

      const position = imovel.id;

      dataLayer.push({
        'event': 'productClick',
        'ecommerce': {
        'click': {
        'actionField': {'list': 'Resultado de busca - Agenci'},
        'products': [{
        'name': imovelInfo.TituloImovel,
        'id': imovelInfo.Codigo,
        'price': preco,
        'brand': imovelInfo.Empreendimento,
        'category': imovelInfo.CategoriaImovel,
        'list': 'Busca',
        'position': itemPosition,
        'dimension1' : finalidade(),
        'dimension2' : imovelInfo.CategoriaImovel,
        'dimension3' : imovelInfo.Bairro,
        'dimension4' : preco,
        'dimension6' : imovelInfo.Dormitorios,
        'dimension6' : imovelInfo.BanheiroSocialQtd,
        'dimension7' : imovelInfo.Vagas,
        'dimension8' : imovelInfo.InfraEstrutura.Face,
        'dimension9' : imovelInfo.Empreendimento,
        'dimension10' : imovelInfo.AreaTotal,
        'dimension11' : imovelInfo.AreaPrivativa,
        'dimension12' : imovelInfo.AnoConstrucao,
        'dimension13' : imovelInfo.Zoneamento,
        'dimension14' : imovelInfo.Imediacoes
        }]
        }
        } });
    });
  })
  }

  listarImoveis(paginacao = 1) {
    const values = {"advFilter":finalidadeParametro(), 'fields':['Status', 'Bairro', 'CodigoAgencia', 'CategoriaImovel', 'TituloImovel', 'EmConstrucao', 'ProntoNovoMorar', 'ProntoParaMorar', 'ProntoMorar', 'Lancamento', 'LancamentosProntos', 'Lancamentos2', 'Proposta', 'Dormitorios', 'AreaPrivativa', 'FotoDestaque', 'FotoDestaquePequena', 'ValorVenda', 'ValorLocacao', 'Proposta', 'OcultarPrecoSite', 'InfraEstrutura', 'Empreendimento', 'BanheiroSocialQtd', 'Vagas', 'AnoConstrucao', 'Zoneamento', 'Imediacoes', 'AreaTotal', 'OrdemSite'], 'order': JSON.parse(agenciaOrder), 'paginacao': {'pagina': paginacao, 'quantidade': 9}};
    pesquisarImoveis(values, 'total', (cb) => {
      const element = document.querySelector('#agencia-cards');
      if (element.children.length === 3) {
        const nodes = Array.from(element.children);
        nodes.forEach((node) => {
          element.removeChild(node);
        })
      } else {
        const nodes = Array.from(element.children);
        nodes.forEach((node) => {
          element.appendChild(node);
        })
      }
      this.paginasTotal = cb.extra.paginas;
      cb.imovel.forEach((imovel) => {
        const url = `${removeAccents(imovel.CategoriaImovel)}-${removeAccents(imovel.AreaPrivativa)}m2-${imovel.Status}-${removeAccents(imovel.Bairro)}-${imovel.Codigo}/`.toLowerCase();
        let badge = '';
        const valorSobConsulta = Array('63509');

        if (imovel.ProntoNovoMorar === 'Sim' || imovel.ProntoParaMorar === 'Sim' || imovel.ProntoMorar === 'Sim') {
          badge = `<span class="badge-prontoNovoMorar">Pronto para morar</span>`;
        } else if (imovel.Lancamento === 'Sim' || imovel.Lancamentos2 === 'Sim') {
          badge = `<span class="badge-lancamento">Lançamento</span>`;
        }
        if (imovel.EmConstrucao === 'Sim') {
          badge += `<span class="badge-EmConstrucao">Em Construção</span>`;
        }
        if (typeof phpData.tags[imovel.Codigo] !== "undefined") {
          phpData.tags[imovel.Codigo].forEach((element) => {
            badge += `<span class="badge-padrao">${element}</span>`;
          });
        }
        if (badge !== '') {
          badge = `<div class="badge">${badge}</div>`;
        }

        const html = `<div class="col-12 col-md-4 shimmer-card">
                        <a class="card-link" href="${phpData.homeurl}imovel/${url}" target="_blank">
                          <div class="imovel-content-card">
                            <div class="relative">
                              <div class="relative border-radius-top placeholder" data-large="${imovel.FotoDestaque.replace("http://", "https://")}">
                                <img class="object-fit-image img-small" src="${imovel.FotoDestaquePequena.replace("http://", "https://")}" alt="${imovel.TituloImovel}" loading="lazy">
                                ${badge}
                                ${imovel.Proposta === 'Sim' ? '<span class="badge-reservado">Imóvel com proposta</span>' : ''}
                                <div class="card-animation card-animation-second"></div>
                              </div>
                              <div class="imovel-content-card-info d-flex flex-column align-items-start justify-content-around">

                                  <h3>${imovel.Bairro}</h3>

                                <p>${imovel.TituloImovel}</p>
                                <div class="group-icons d-flex flex-wrap align-items-center justify-content-start">
                                  ${
                                    imovel.Dormitorios ?
                                      `<div class="d-flex align-items-center">
                                        <img class="quartos" src="${phpData.assetsurl}src/assets/images/beds.svg" alt="Quantidade de quartos" loading="lazy">
                                        <span>${imovel.Dormitorios} Quartos</span>
                                      </div>` : ''
                                  }
                                  <div class="d-flex align-items-center">
                                    <img class="tamanho" src="${phpData.assetsurl}src/assets/images/size.svg" alt="Metragem do imovel" loading="lazy">
                                    <span>${imovel.AreaPrivativa}m²</span>
                                  </div>
                                  ${imovel.OcultarPrecoSite !== 'Sim' && !valorSobConsulta.includes(imovel.Codigo) ?
                                    `<div class="align-self-end flex-grow-1">
                                      <p class="price">R$ ${imovel.Status === 'VENDA' ? returnCurrency(imovel.ValorVenda) : returnCurrency(imovel.ValorLocacao)}</p>
                                    </div>` : ''
                                  }
                                  ${valorSobConsulta.includes(imovel.Codigo) ?
                                    `<div class="align-self-end flex-grow-1">
                                      ${valorSobConsulta.includes(imovel.Codigo) ? `<span class="badge-valor-sob-consulta">Valor Sob Consulta</span>` : ''}
                                    </div>` : ''
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="tracker-info" style="display: none;" data-tracker='${JSON.stringify(imovel)}'></div>
                          </div>
                        </a>
                      </div>`;
        element.insertAdjacentHTML('beforeend', html);
      })
      //this.mountPaginationTemplate(paginacao, this.paginasTotal, cb.extra.total, this, this.listPaginationPages);
      const cards = Array.from(document.querySelectorAll('#agencia-cards .shimmer-card .imovel-content-card'));
      loadCardImages(cards, 'object-fit-image', 'shimmer-card')
      matchHeightElements('#agencia-cards .imovel-content-card');
      this.setDataLayerAgenciaUnico('#agencia-cards', paginacao);
      this.insertListaBanner();
    });

  }
  insertListaBanner () {
    const cartImoveis = document.querySelectorAll('.col-12.col-md-4');
    const getRandomArbitrary = (min, max) => {
      return Math.floor(Math.random() * (max - min)) + min;
    }
    let min = 0 + 9 * this.aux;
    let i = getRandomArbitrary(min, cartImoveis.length);
    if(this.aux < this.bannerArrayHtml.length){
      cartImoveis[i].insertAdjacentHTML('afterend', this.bannerArrayHtml[this.aux]);
      this.aux++;
    }
  }
 infiniteScroll () {
    let this_ = this;
    let controller = new Controller();
    this_.pagina = 2;
    let scene = new Scene({triggerElement: "#infinite-scroll", triggerHook: "onEnter"})
    .addTo(controller)
    .on("enter", function (e) {
      if (this_.pagina <= this_.paginasTotal) {
        this_.listarImoveis(this_.pagina);
        this_.pagina++;
      }
    });
  }

  listarBanner () {
    this.infiniteScroll();
    listarBannerGDN((banner) => {
      if (banner.data.ativar_banner_gdn) {
        let arrayHtml = banner.data.banner.map((e) => {
          return `<div class="col-12 col-md-6 col-lg-4">
                  <a class="card-link" href="${e.url_banner_gdn}" target="_blank">
                    <div class="banner_gdn">
                      <div class="relative border-radius-top placeholder" data-large="${e.imagem_banner_gdn}">
                        <img class="loaded" src="${e.imagem_banner_gdn}" alt="${e.titulo_banner_gdn}" loading="lazy">
                        <div class="card-animation card-animation-second"></div>
                      </div>
                    </div>
                  </a>
                </div>`;
        });

        for(let i = arrayHtml.length - 1; i > 0; i--) {
          const randomIndex = Math.floor(Math.random() * (i + 1));

          arrayHtml.push(arrayHtml[randomIndex]);
          arrayHtml.splice(randomIndex, 1);
        }

        this.bannerArrayHtml = arrayHtml;
        this.insertListaBanner();
      }
    });
  }

}

export default agencia;



// WEBPACK FOOTER //
// ./src/assets/js/page-agencia.js